export const SET_CONTRIES_FORECAST = "SET_CONTRIES_FORECAST";
export const SET_DATA_FORECAST = "SET_DATA_FORECAST";
export const SET_URL_EXPORT = "SET_URL_EXPORT";
export const SET_LOADING_APPLY_FORECAST = "SET_LOADING_APPLY_FORECAST";
export const SET_DATA_FE_FORECAST = "SET_DATA_FE_FORECAST";
export const SET_DATA_LAST_TRIMESTER = "SET_DATA_LAST_TRIMESTER";
export const SET_DATA_CONSENSUS_REPORT = "SET_DATA_CONSENSUS_REPORT";
export const SET_DATA_CONSENSUS_REPORT_ENDOGENIZE = "SET_DATA_CONSENSUS_REPORT_ENDOGENIZE";
export const SET_FORECAST_STATUS = "SET_FORECAST_STATUS";
export const SET_FORECAST_ERROR = "SET_FORECAST_ERROR";
export const SET_FORECAST_LOAD_STARTED = "SET_FORECAST_LOAD_STARTED";
export const SET_FORECAST_V2 = "SET_FORECAST_V2";
export const SET_FORECAST_V2_STATUS = "SET_FORECAST_V2_STATUS";
export const SET_DIAGNOSTICS = "SET_DIAGNOSTICS";
export const SET_DIAGNOSTICS_STATUS = "SET_DIAGNOSTICS_STATUS";
